<template>
    <div>
        <div class="card-container">
            <!-- <v-card class="card-body"> -->
            <!-- {{ testLabel }} -->
            <slot></slot>
            <!-- </v-card> -->
        </div>
    </div>
</template>
  
<script>
export default {
    name: "Card",
    // props: {
    //     testLabel: {
    //         default: ''
    //     }
    // }
}
</script>
  
<style scoped>
con {
    background: palegreen;
}

.card-container {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

/* .card-body {
    position: relative;
    display: flex;
    width: 325px;
    padding: 24px;
    flex-direction: column;
    align-items: center;
    border-radius: 16px;
} */
</style>